import { EditorState } from 'draft-js';

/**
 * Get selection for an entity by current cursor position
 * @param {EditorState} editorState
 */
export function getEntityConsecutiveSelection(editorState) {
	const selection = editorState.getSelection();

	if (!selection.isCollapsed()) {
		return selection;
	}

	const startKey = selection.getStartKey();
	const startOffset = selection.getStartOffset();
	const prevOffset = startOffset - 1;
	const block = editorState.getCurrentContent().getBlockForKey(startKey);
	const characterList = block.getCharacterList();
	const prevChar = characterList.get(prevOffset);
	const nextChar = characterList.get(startOffset);

	if (!prevChar || !nextChar) {
		return selection;
	}

	const prevEntity = prevChar.getEntity();
	const nextEntity = nextChar.getEntity();
	const entity = prevEntity === nextEntity && prevEntity;

	if (!entity) {
		return selection;
	}

	let finalPrevOffset = prevOffset;
	let finalNextOffset = startOffset;

	while(finalPrevOffset > 0) {
		finalPrevOffset--;
		const char = characterList.get(finalPrevOffset);
		if (char.getEntity() !== entity) {
			finalPrevOffset++;
			break;
		}
	}

	const blockLength = block.getLength();
	while(finalNextOffset < blockLength) {
		finalNextOffset++;
		const char = characterList.get(finalNextOffset);
		if (!char || char.getEntity() !== entity) {
			break;
		}
	}

	return selection.merge({
		anchorOffset: finalPrevOffset,
		focusOffset: finalNextOffset,
	});
}



// WEBPACK FOOTER //
// ./lib/helpers/getEntityConsecutiveSelection.js